import React from "react";

//material ui
import { useTheme } from "@mui/styles";
import { Box, Typography, useMediaQuery } from "@mui/material";

//json2mq
import json2mq from "json2mq";

const useStyles = (theme, isMobile) => ({
  container: {
    display: "flex",
    flexDirection: { xs: "column" },
    alignItems: { xs: "center" },
    mt: isMobile ? "30px" : 0,
    // outline: "1px solid red",
    height: { xs: "780px", md: "720px", lg: "720px", xl: "670px" },
  },
  card: {
    display: "flex",
    flexDirection: { xs: "column" },
    alignItems: { xs: "center" },
    justifyContent: { xs: "space-between" },
    boxShadow: "0 10px 10px 0 rgba(0, 0, 0, 0.05)",
    borderRadius: { xs: "40px" },
    width: isMobile ? "288px" : { xl: "438px", lg: "320px", md: "240px" },
    minHeight: { xs: "534px" },
    mb: { xs: "54px" },
    border: "solid 1px #f2f2f2",
    // outline: "1px solid blue",
    // padding: "0px 48px",
    flexGrow: 1,
  },
  name: {
    mt: { xs: "17.6px", md: 0 },
    fontSize: { xs: "30px", md: "20px", lg: "25px", xl: "30px" },
    lineHeight: { xs: "36px" },
    textAlign: { xs: "center" },
    fontFamily: theme.typography.montserrat.bold,
    color: theme.palette.blue.main,
  },
  testimony: {
    mt: { xs: "26.3px", md: "5px", xl: "26.3px" },
    fontSize: { xs: "14px", lg: "14px", xl: "15px" },
    lineHeight: { xs: "auto", md: "17px", lg: "20px", xl: "25px" },
    textAlign: { xs: "center" },
    fontFamily: theme.typography.anaHeim.regular,
    color: theme.palette.blue.tertiary,
    // width: { xs: "225px", md: "220px", lg: "300px" },
    padding: { xs: "0px 48px", md: "0px 24px", lg: "0px 48px" },
    minHeight: { xs: "150px", md: "200px" },
  },
  logo: {
    margin: isMobile ? "30px auto 20px auto" : "30px auto 30px auto",
    width: "176px",
    height: "45px",
    objectFit: "contain",
  },
});

const TestimonyCard = ({ name, description, img, company }) => {
  const isMobile = useMediaQuery("(max-width:899px)");

  const theme = useTheme();
  const classes = useStyles(theme, isMobile);

  const xs = useMediaQuery(
    json2mq({
      maxWidth: 899,
    })
  );

  const xl = useMediaQuery(
    json2mq({
      minWidth: 1536,
    })
  );

  const stylesHelper = () => {
    if (xl)
      return {
        img: {
          width: "200px",
          height: "200px",
          marginTop: "-32px",
          marginBottom: "-48px",
        },
      };
    else if (xs)
      return {
        img: {
          width: "200px",
          height: "200px",
          marginTop: "-32px",
          marginBottom: "-64px",
        },
      };
  };

  return (
    <Box sx={classes.container}>
      <Box sx={classes.card}>
        <Box
          sx={{
            mt: { xs: "20px", md: "-16px", lg: "0px", xl: "25px" },
            mb: { xs: "20px", md: "-64px", lg: "-48px", xl: "25px" },
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <img
            src={img}
            alt="persona"
            style={stylesHelper() && stylesHelper().img}
          />
        </Box>

        <Typography sx={classes.name}>{name}</Typography>
        <Typography sx={classes.testimony}>{description}</Typography>

        {company ? (
          <img
            src={company}
            alt="Logo de la compañía"
            style={{ ...classes.logo }}
          />
        ) : (
          <div style={{ ...classes.logo }} />
        )}
      </Box>
    </Box>
  );
};

export default TestimonyCard;
